import styles from "./empty-dashboard.module.css";
import React, { useEffect, useContext, useState } from "react";
import tokenService from "services/token.service";
import EmptyAdminDashboard from "./empty-admin-dashboard";
import EmptyCaptainDashboard from "./empty-captain-dashboard";
import EmptyPlayerDashboard from "./empty-player-dashboard";
import { MembershipContext } from "hoc/membership-data";
import instance from "services/api";
import Spinner from "components/functional/spinner";

const EmptyDashboard = () => {
  const membershipData = useContext(MembershipContext);

  const [preferences, setPreferences] = useState("");
  const [profileCompleteness, setProfileCompleteness] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const role = tokenService.getRole();
  const is_admin = role === "admin";

  const { teams } = membershipData;
  const { is_captain, team_id } = teams[0];

  const profileCompleted = profileCompleteness?.isUserProfileComplete
    ? "success"
    : "pending";

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const preferencesResponse = await instance.get(
          `/team-preferences/${team_id}`
        );
        setPreferences(preferencesResponse.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }

      try {
        const profileResponse = await instance.get(
          `/users/${tokenService.getUserId()}/profile-completed`
        );
        setProfileCompleteness(profileResponse.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [team_id]);

  if (isLoading) {
    return <Spinner />; // Or a loading spinner
  }

  return (
    <div className={styles["dashboard-empty"]}>
      {is_admin ? (
        <EmptyAdminDashboard
          preferences={preferences}
          profile={profileCompleted}
          team_id={team_id}
        />
      ) : is_captain ? (
        <EmptyCaptainDashboard
          preferences={preferences}
          profile={profileCompleted}
          team_id={team_id}
        />
      ) : (
        <EmptyPlayerDashboard
          profile={profileCompleted}
          team_id={team_id}
          preferences={preferences}
        />
      )}
    </div>
  );
};

export default EmptyDashboard;
